import React, {useState} from "react";
import AuthService from "../../services/auth.service";
import CatalogSearch from "../Books/CatalogSearch";
import "./style.css";

export default function Navbar({currentUser, setCurrentUser, booksLike, authorsLike, setBooksLike, setAuthorsLike}) {
    const [showDropdown, setShowDropdown] = useState(false);
    const logOut = async () => {
        try {
            await AuthService.logout();
            setCurrentUser(undefined);
            setShowDropdown(false);
        } catch { /* Keep the existing session visible when logout fails. */ }
    };
    return <div className="restored-navigation">
        <header className="navbar p-0 navbar-expand navbar-dark flex-column flex-sm-row bd-navbar">
            <a href="/" className="navbar-brand nav-header">
                <img src="/favicon.ico" className="ms-2 me-2 mb-2" width="23" alt=""/>
                Подбор книг
                <img src="/pepe.gif" alt="" width="50" height="50" className="me-3 ms-2 mb-3 mb-sm-2"/>
            </a>
            <nav className="navbar-nav-scroll" aria-label="Основная навигация">
                <ul className="navbar-nav bd-navbar-nav flex-row nav-ul-scroll">
                    <li className="nav-item"><a className="nav-link" href="/">Подобрать книгу</a></li>
                    <li className="nav-item"><a className="nav-link" href="/blog">Новости</a></li>
                    <li className="nav-item"><a className="nav-link" href="/subscriptions">Мои подписки</a></li>
                    <li className="nav-item ms-auto">
                        <button className="btn btn-secondary bg-transparent border-0 account-toggle" type="button"
                                aria-label="Аккаунт" aria-expanded={showDropdown} aria-controls="account-menu"
                                onClick={() => setShowDropdown(open => !open)}
                                onKeyDown={event => { if (event.key === 'Escape') setShowDropdown(false); }}>
                            <i className="far fa-user-circle fa-2x" aria-hidden="true"/>
                        </button>
                    </li>
                </ul>
            </nav>
        </header>
        {setBooksLike && setAuthorsLike && <div className="restored-search">
            <CatalogSearch booksLike={booksLike} authorsLike={authorsLike}
                           setBooksLike={setBooksLike} setAuthorsLike={setAuthorsLike}/>
        </div>}
        {showDropdown && <div id="account-menu" className="account-menu"
                             onKeyDown={event => {
                                 if (event.key === 'Escape') {
                                     const toggle = event.currentTarget.parentElement.querySelector('.account-toggle');
                                     setShowDropdown(false);
                                     toggle?.focus();
                                 }
                             }}>
            {currentUser ? <>
                <div className="text-center border-bottom"><span>{currentUser.username}</span></div>
                <a className="dropdown-item mt-3" href="/cabinet">Личный кабинет</a>
                <button type="button" className="dropdown-item" onClick={logOut}>Выйти</button>
            </> : <>
                <a className="dropdown-item" href="/login">Войти</a>
                <a className="dropdown-item" href="/signup">Регистрация</a>
            </>}
        </div>}
    </div>;
}
